import Storage from '../Storage.js';

Storage.setConfig("mailing_states", {
  config: {
    method: "mailing_states/",
    title: "Статусы",
    objectName: "Статус",
    adminGroup: true
  },
  properties: {
    id: {
      default: false,
      type: "text",
      title: "#",
      preset: true,
      width: "20px"
    },
    create_time: {
      default: "",
      type: "text",
      title: "Создан",
      preset: true,
      width: false
    },
    update_time: {
      default: "",
      type: "text",
      title: "Обновлен",
      preset: true,
      width: false
    },
    name: {
      default: "",
      type: "text",
      title: "Имя",
      preset: false,
      width: "auto"
    },
    default: {
      default: false,
      type: "checkbox",
      title: "По умолчанию",
      preset: false,
      width: "auto"
    },
    secondary: {
      default: false,
      type: "checkbox",
      title: "Вторичный",
      preset: false,
      width: "auto"
    },
  }
});



// WEBPACK FOOTER //
// ./src/config/mailing_states.js